<template>
  <div class="">
    <h4 class="text-[24px] leading-[28px] font-medium">{{ in18['page_coupon_code_title'] }}</h4>
    <form class="w-full flex">
      <input
          v-model="couponCode"
          :disabled="couponApplied"
          :placeholder="in18['page_coupon_code_placeholder']"
          class="rounded-[8px] border border-light-gray/25 px-[16px] py-[14px] text-[16px] mr-[8px] bg-white outline-none focus-within:border-lime-green transition-all flex-grow"
          type="text"
      />

      <button
          v-if="!couponApplied"
          :disabled="inProgress || !this.couponCode"
          class="px-[28px] py-[14px] text-charcoal text-[16px] border border-charcoal bg-white  transition-all rounded-[8px]  "
          :class="[inProgress || !this.couponCode ? 'cursor-not-allowed ' : 'hover:bg-lime-green hover:border-lime-green hover:text-white' ]"
          type="submit"
          @click.prevent="applyCoupon"
      >
        {{ in18['page_coupon_apply_code_btn'] }}
      </button>
      <button
          v-else
          :disabled="inProgress"
          class="px-[28px] py-[14px] text-charcoal text-[16px] border border-[#EB2735] bg-white hover:bg-[#EB2735] transition-all rounded-[8px] hover:text-white"
          type="button"
          @click.prevent="removeCoupon"
      >
        {{ in18['page_coupon_remove_code_btn'] }}
      </button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    cart:       {
      type: Object,
    },
    in18:       {
      type: Object,
    },
    inProgress: {
      type: Boolean,
    },
  },

  emits: [
    'update-cart',
    'update-in-progress'
  ],

  data() {
    return {
      couponCode:    this.cart.coupon ? this.cart.coupon.code : '',
      couponApplied: !!this.cart.coupon,
    };
  },

  methods: {

    /**
     * Apply the entered coupon code to the cart.
     */
    applyCoupon() {

      if (this.inProgress || !this.couponCode) {
        return;
      }

      this.$emit('update-in-progress', true);

      axios
          .post('/api/coupon/apply', {
            code: this.couponCode,
          })
          .then((response) => {
            let cart = response.data.cart;
            window.toastr.success(response.data.message);
            this.$emit('update-cart', cart);
            this.couponCode = cart.coupon ? cart.coupon.code : '';
            this.couponApplied = true;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
            this.couponCode = '';
          })
          .finally(() => {
            this.$emit('update-in-progress', false);
          });
    },

    /**
     * Remove the applied coupon code from the cart.
     */
    removeCoupon() {

      if (confirm(this.in18['page_coupon_remove_confirm']) !== true) {
        return;
      }

      if (this.inProgress || !this.couponCode) {
        return;
      }

      this.$emit('update-in-progress', true);

      axios
          .post('/api/coupon/remove/')
          .then((response) => {
            // console.log(response.data.cart);
            window.toastr.success(response.data.message);
            this.$emit('update-cart', response.data.cart);
            this.couponCode = '';
            this.couponApplied = false;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
            console.error(error.response);
          })
          .finally(() => {
            this.$emit('update-in-progress', false);
          });
    },
  },
};
</script>
